import type { AttributeNode } from '../../types';
import { ConditionCard } from '../condition-card';
import { FieldOperatorValue } from '../condition-parts';

type AttributeConditionProps = { node: AttributeNode };

export function AttributeCondition({ node }: AttributeConditionProps) {
  return (
    <ConditionCard node={node}>
      <FieldOperatorValue field={node.field} operator={node.operator} value={node.value} value2={node.value2} />
    </ConditionCard>
  );
}
